export const ApckPromptDialog = {
    props: {
        label: {
            type: String,
            default: ""
        },
        message: {
            type: String,
            default: ""
        },
        value: {
            type: [String, Number, Boolean],
            default: ""
        },
        rows: {
            type: Number,
            default: 0
        },
        type: {
            type: String,
            default: "text"
        }
    },
    data() {
        return {
            newValue: ""
        }
    },
    mounted () {
        this.newValue = this.value;
        this.$refs.dialogInput.focusField();
    },
    methods: {
        accept() {
            const data = {};
            data.status = true;
            data.value = this.newValue;
            this.$emit('close', data);
        },
        deny() {
            const data = {};
            data.status = false;
            this.$emit('close', data);
        },
    },
    template: `
        <div class="alert-dialog">
            <p v-show="message">{{message}}</p>
            <apck-field>
                <apck-text
                    ref="dialogInput"
                    v-model="newValue"
                    :show-label="false"
                    :rows="rows"
                    :type="type"
                    :autofocus="true"
                    @enter-pressed="accept"
                />
            </apck-field>
            <div class="pull-right">
                <span class="btn-positive btn-short btn" v-on:click="accept">OK</span>
                <span class="btn-negative btn-short btn" v-on:click="deny">Cancel</span>
            </div>
        </div>
    `
}
